<template>
	<div class="link-select">
		<link-input
			ref="input"
			:value="p_inputValue==null?showValue:p_inputValue"
			@input="lv_input"
			:readonly="lv_readonly"
			:inputReadonly="!!multiple || !filterable"
			:type="type"
			:color="color"
			:size="size"
			:shape="shape"
			:dashed="dashed"
			:long="long"
			:prefix-icon="prefixIcon"
			:suffix-icon="p_suffixIcon"
			:placeholder="placeholder"
			:disabled="lv_disabled"
			:width="width"
			:regexp="regexp"
			:clear-on-click-delete-icon="false"
			:hide-clear-icon="hideClearIcon"
			:required="required"
			:validate-on-init="validateOnInit"
			:rules="rules"
			@click-suffix-icon="!lv_disabled&&!lv_readonly && p_clear()"
			@click="!lv_disabled&&!lv_readonly&&lv_clickInput()"
			@enter="lv_enter"
			@keydown.up.prevent="lv_up"
			@keydown.down.prevent="lv_down"/>
		<link-popover :reference="lv_mounted?$refs.input:null" v-model="currentShow" ref="popover" @hide="p_inputValue = null" :popper="{height:height}">
			<div class="pl-select-content">
				<div class="link-select-item" ref="items" v-for="(item,index) in p_filterData" :label="item.label" :value="item.value" :key="index" @click="p_click(item,index)"
					 :class="{'link-select-item-active':item.checked,'link-select-item-selected':selectIndex === index}">
					<slot :item="item.item" :index="index" :checked="item.checked">
						<span>{{item.label}}</span>
					</slot>
				</div>
			</div>
		</link-popover>
	</div>
</template>

<script>
	import {EditMixin, MountedMixin} from '../mixins';
	import PlPopover from '../popover/pl-popover';

	export default {
		name: "link-select",
		components: {PlPopover},
		mixins: [EditMixin, MountedMixin],
		props: {
			value: {default: null},
			show: {type: Boolean, default: false},
			height: {type: Number, default: 180},
			sizeEqual: {type: Boolean, default: true},
			dropdownWidth: {default: '100%'},
			multiple: {type: Boolean, default: false},
			data: {type: Array | Promise},
			valKey: {type: String,},
			labelKey: {type: String,},
			beforeSelect: {type: Function},
			afterSelect: {type: Function},
			displayFormat: {},                                                      //显示值格式化
			filterable: {type: Boolean, default: true},                             //是否可输入筛选
			showValueWhenNoMatch: {type: Boolean},                                  //当没有数据值匹配时，是否显示原值

			type: {default: 'line',},
			color: {default: 'info',},
			size: {default: 'default',},
			shape: {default: 'none',},
			dashed: {type: Boolean,},
			long: {type: Boolean,},
			prefixIcon: {type: String},
			suffixIcon: {type: String},
			placeholder: {type: String, default: () => LinkVue.$t('LinkForm.selectPlaceholder')},
			regexp: {type: RegExp},
			width: {type: Number},
			hideClearIcon: {type: Boolean},
			required: {type: Boolean},
			rules: {type: Array | String},
			validateOnInit: {type: Boolean,},

			trigger: {type: String, default: 'click'},                              //触发的动作：hover|click
			disabledHideOnClickOutside: {type: Boolean},                            //禁用点击外部的时候关闭弹出框
			disabledDestroyOnHide: {type: Boolean},                                 //禁用隐藏的时候销毁内容
			disabledEqual: {type: Boolean},                                         //弹出框是否与载体在方向上大小相同

		},
		watch: {
			value(val) {
				if (!!this.multiple && this.p_multipleValue !== val) this.p_multipleValue = this.$lv.$utils.deepCopy(val)
				else if (this.p_singleValue !== val) this.p_singleValue = val
				this.p_reset();
			},
			p_multipleValue(val) {
				if (JSON.stringify(val) !== JSON.stringify(this.value)) this.$emit('input', val);
			},
			p_singleValue(val) {
				this.$emit('input', val);
			},
			show(val) {
				if (this.currentShow !== val) this.currentShow = val
			},
			currentShow(val) {
				this.$emit('update:show', val)
			},
			data() {
				this.p_reset()
			},
			labelKey() {
				this.p_reset()
			},
			valKey() {
				this.p_reset()
			},
		},
		data() {
			return {
				currentShow: this.show,
				p_selectItems: [],
				p_singleValue: this.value,
				p_multipleValue: this.$lv.$utils.deepCopy(this.value) || [],
				p_inputValue: null,
				p_data: [],
				showValue: null,
				p_showAllOption: true,
				selectIndex: null,
			}
		},
		computed: {
			p_suffixIcon() {
				return this.currentShow ? 'link-icon-up' : 'link-icon-down'
			},
			currentValue() {
				return this.multiple ? this.p_multipleValue : this.p_singleValue
			},
			p_filterData() {
				if ((!this.p_showAllOption && !!this.filterable && !!this.p_inputValue)) {
					return this.p_data.filter(dataItem => (dataItem.label || '').toLowerCase().indexOf(this.p_inputValue.toLowerCase()) > -1)
				} else {
					return this.p_data
				}
			},
		},
		created() {
			this.p_reset()
		},
		methods: {
			async p_clear() {
				if (!!this.lv_disabled || !!this.lv_readonly) return
				!!this.beforeSelect && (await this.beforeSelect(this.currentValue))

				this.multiple ? (this.p_multipleValue = []) : (this.p_singleValue = null)
				this.p_data.forEach(item => item.checked = false)

				!!this.afterSelect && (await this.afterSelect(this.currentValue))
			},
			async p_reset() {
				let list = this.data || []
				if (this.$lv.$utils.typeOf(list) === 'promise') {
					list = await list
				}

				this.p_data = list.map((item, index) => {
					const label = !!this.labelKey ? item[this.labelKey] : item
					const value = !!this.valKey ? item[this.valKey] : item
					return {
						item: list[index],
						label,
						value,
						checked: !this.multiple ? (value === this.p_singleValue) : this.$lv.$utils.oneOf(value, this.p_multipleValue),
					}
				})
				this.resetShowValue()
			},
			async p_click(item, index) {
				if (!this.multiple) {
					this.p_data.forEach(i => i.checked = false)
					this.p_singleValue = item.value;
					item.checked = true
					this.currentShow = false
				} else {
					item.checked = !item.checked
					!!item.checked ? this.p_multipleValue.push(item.value) : this.$lv.$utils.removeFromArray(this.p_multipleValue, item.value);
				}
				this.$emit('click', {item, index})
				this.$emit('select', !!this.multiple ? this.p_multipleValue : this.p_singleValue)

				!!this.afterSelect && (await this.afterSelect(this.currentValue))
				this.resetShowValue()
			},
			async lv_clickInput() {
				if (!this.currentShow) this.p_openDropdown()
				else {
					this.currentShow = false
				}
			},
			async p_openDropdown() {
				!!this.beforeSelect && (await this.beforeSelect(this.currentValue))
				this.selectIndex = null
				this.currentShow = true
			},
			async resetShowValue() {
				this.p_showAllOption = true

				if (!!this.displayFormat) {
					this.showValue = this.displayFormat(this.p_data, this.currentValue)
					return
				}
				if (!!this.multiple)
					this.showValue = this.p_data.reduce((ret, item) => {
						!!item.checked && ret.push(item.label)
						return ret
					}, []).join(',')
				else {
					const retItem = this.$lv.$utils.findOne(this.p_data, item => !!item.checked)
					if (!!retItem) {
						this.showValue = retItem.label
					} else {
						if (this.showValueWhenNoMatch) {
							this.showValue = this.value
						} else {
							this.showValue = null
						}
					}
				}
			},
			async lv_input(val) {
				this.p_inputValue = val
				this.p_showAllOption = !val
				if (!this.currentShow && document.activeElement === this.$refs.input.$refs.input) {
					this.p_openDropdown()
				}
			},
			async lv_enter() {
				if (!this.currentShow) {
					this.p_openDropdown()
				} else {
					if (!this.filterable) return
					if (this.p_filterData.length === 1) {
						this.p_click(this.p_filterData[0], 0)
					} else if (null != this.selectIndex && !!this.$refs.items[this.selectIndex]) {
						this.p_click(this.p_filterData[this.selectIndex], this.selectIndex)
					}
				}
			},
			async lv_up() {
				if (this.selectIndex == null) {
					this.selectIndex = 0
					return
				}
				if (this.selectIndex > 0) {
					this.selectIndex--
					const item = this.$refs.items[this.selectIndex]
					const wrapper = this.$refs.popover.$refs.scroll.$refs.wrapper
					if (wrapper.scrollTop > item.offsetTop) {
						this.$refs.popover.$refs.scroll.scrollTop(item.offsetTop, 25)
					}
				} else {
					this.selectIndex = this.p_filterData.length - 1
					this.$refs.popover.$refs.scroll.scrollTop(this.$refs.items[this.$refs.items.length - 1].offsetTop, 25)
				}
			},
			async lv_down() {
				if (this.selectIndex == null) {
					this.selectIndex = 0
					return
				}
				if (this.selectIndex < (this.p_filterData.length - 1)) {
					this.selectIndex++
					const item = this.$refs.items[this.selectIndex]
					const wrapper = this.$refs.popover.$refs.scroll.$refs.wrapper
					const scrollTop = item.offsetTop + item.offsetHeight - wrapper.offsetHeight
					if (scrollTop > 0 && scrollTop > wrapper.scrollTop) {
						this.$refs.popover.$refs.scroll.scrollTop(scrollTop, 25)
					}
				} else {
					this.selectIndex = 0
					this.$refs.popover.$refs.scroll.scrollTop(0, 25)
				}
			},
			async lv_clickOutSide() {
				this.resetShowValue()
			},
		}
	}
</script>

<style lang="scss">
	@include themeify {
		.link-select {
			display: inline-block;
			vertical-align: bottom;
			box-sizing: border-box;
			cursor: pointer;
		}

		.pl-select-content {
			padding: 3px;
			box-sizing: border-box;
			width: 100%;

			.link-select-item {
				padding: 4px 9px;
				font-size: 12px;
				cursor: pointer;
				color: $auto-table-body-color;
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-sizing: border-box;

				&:hover, &.link-select-item-selected {
					background-color: $color-primary-light;
				}

				&.link-select-item-active {
					background-color: $color-primary;
					color: white;
				}

				&:not(:last-child) {
					margin-bottom: 3px;
				}
			}
		}
	}
</style>
